const callLogDrillDownfilterSortReducer = (
    state = {},
    action: {
      type: "SET_CALLLOGDRILLDOWN_FILTER_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_CALLLOGDRILLDOWN_FILTER_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default callLogDrillDownfilterSortReducer;